import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { EnvioRecado, MedicoRecado, Recado } from '../../interfaces/recados.dto';

const ARQUIVO_GRANDE = 'O arquivo é grande demais para o servidor. Tente um arquivo menor.';

/** Chat médico: o back responde CustomReturn ({ data: [] }); erros sobem como Error(mensagem). */
@Injectable({ providedIn: 'root' })
export class RecadosService {
  private readonly apiURL = `${environment.apiUrl}/v${environment.apiVersion}/recados`;

  constructor(private http: HttpClient) {}

  async medicos(): Promise<MedicoRecado[]> {
    return this.dados(this.http.get<any>(`${this.apiURL}/medicos`), 'Não foi possível carregar os médicos agora.');
  }

  async listar(): Promise<Recado[]> {
    return this.dados(this.http.get<any>(this.apiURL), 'Não foi possível carregar os recados agora.');
  }

  async naoLidos(): Promise<number> {
    const d = await this.dados<number>(this.http.get<any>(`${this.apiURL}/nao-lidos`), 'Não foi possível consultar os recados agora.');
    return d[0] ?? 0;
  }

  async eu(): Promise<string> {
    const d = await this.dados<string>(this.http.get<any>(`${this.apiURL}/eu`), 'Não foi possível identificar o usuário agora.');
    return d[0] ?? '';
  }

  async enviar(e: EnvioRecado): Promise<Recado> {
    const d = await this.dados<Recado>(this.http.post<any>(this.apiURL, e), 'Não foi possível enviar agora. Tente de novo.');
    return d[0];
  }

  async marcarLido(nr: number): Promise<void> {
    await this.dados(this.http.patch<any>(`${this.apiURL}/${nr}/lido`, null), 'Não foi possível marcar como lido.');
  }

  async excluir(nr: number): Promise<void> {
    await this.dados(this.http.delete<any>(`${this.apiURL}/${nr}`), 'Não foi possível excluir o recado.');
  }

  /** Data URL do anexo; a lista só traz o marcador '__img__'. */
  async anexo(nr: number): Promise<string> {
    const d = await this.dados<string>(this.http.get<any>(`${this.apiURL}/${nr}/anexo`), 'Não foi possível abrir o anexo.');
    return d[0] ?? '';
  }

  private async dados<T = any>(chamada: ReturnType<HttpClient['get']>, padrao: string): Promise<T[]> {
    try {
      const r: any = await firstValueFrom(chamada);
      return Array.isArray(r?.data) ? r.data : [];
    } catch (e: any) {
      throw new Error(mensagemDoErro(e, padrao));
    }
  }
}

function mensagemDoErro(e: any, padrao: string): string {
  if (e?.status === 413) return ARQUIVO_GRANDE;
  if (e?.status === 0) return 'Sem conexão com o servidor. Tente de novo.';
  const c = e?.error;
  return c?.notifications?.[0]?.message ?? c?.error ?? (typeof c?.message === 'string' ? c.message : null) ?? padrao;
}
